import * as React from 'react';
import { ConfigContext } from '../config-provider';
const Empty = () => {
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('empty-img-default');
    const imgSrc = 'https://acd-assets.alicdn.com/acd_work/b-design-doc/illustrations/Can%27t%20find%20content.png';
    return React.createElement("img", { className: prefixCls, src: imgSrc, alt: '' });
};
// export default withConfigProvider(Empty);
export default Empty;
